import { getEnvironment } from "./config";

export async function hardwareProfileActivation(
  accessToken,
  currentUser
): Promise<boolean> {
  return true;
}
